import React from 'react';

export const Select = ({ name, document, updateDocument, options, className }) => {

    function update(e) {
        updateDocument({ [name]: e.target.value })
    }
    const value = document[name] || '';

    return (
        <select onChange={update} className={className} value={value}>
            <option value="">Selectionner</option>
            {options.map((o) => {
                return (
                    <option key={o.value} value={o.value}>
                        {o.label}
                    </option>
                )
            })}
        </select>)
}